import "./index-feature-strip.css";

export default function FeatureStrip({ items }) {
  return (
    <div className="feature-strip">
      {items.map((x, i) => (
        <div className="feature" key={i}>
          <span className="feature-icon">{x.icon}</span>
          <span>{x.label}</span>
        </div>
      ))}
    </div>
  );
}